import ExcelJS from "exceljs";
import { flattenObjectInObjects } from "../candidateListFunctions";

const headings = [
  { key: "sector_name", path: "candidate" },
  { key: "selection_date", path: "candidate" },
  { key: "religion", path: "candidate" },
  { key: "candidate_id", path: "candidate" },
  { key: "name", path: "candidate" },
  { key: "nationality_name", path: "candidate" },
  { key: "job_position_name", path: "candidate" },
  { key: "visa_profession_name", path: "candidate" },
  { key: "approval_remark", path: "candidate" },
  { key: "passport_number", path: "candidate" },
  { key: "dob", path: "candidate" },
  { key: "age", path: "candidate" },
  { key: "selection_grade", path: "candidate" },
  { key: "basic", path: "candidate", title: "Basic Salary" },
  { key: "food", path: "candidate", title: "Food Allowance" },
  { key: "fixed_ot", path: "candidate" },
  { key: "hra", path: "candidate" },
  { key: "travel_allowance", path: "candidate" },
  { key: "mobile_allowance", path: "candidate" },
  { key: "air_ticket_allowance", path: "candidate" },
  { key: "additional_ot", path: "candidate" },
  { key: "other_allowance", path: "candidate" },
  { key: "duty_hours", path: "candidate" },
  { key: "fixed_ot_hours", path: "candidate" },
  { key: "duration_of_contract", path: "candidate" },
  { key: "probation_period", path: "candidate" },
  { key: "passport_issue_date", path: "candidate" },
  { key: "passport_expiry_date", path: "candidate" },
  { key: "emergency_contact_person_in_home_country", path: "candidate" },
  { key: "emergency_contact_number_in_home_country", path: "candidate" },
  { key: "covid_vaccine", path: "candidate" },
  { key: "blood_group", path: "candidate" },
  { key: "status", path: "candidate" },
  { key: "visa_block_number", path: "candidate" },
  { key: "visa_reference_number", path: "candidate" },
  { key: "visa_stamping_date", path: "candidate" },
  { key: "company_name", path: "project" },
  { key: "loan_advance", path: "candidate" },
  { key: "loan_advance_installment", path: "candidate" },
  {
    key: "candidate_flight_flight_details",
    path: "candidate",
    title: "Flight Details",
  },
  {
    key: "candidate_flight_sector_name",
    path: "candidate",
    title: "Flight Sector",
  },
  {
    key: "candidate_flight_date_of_departure",
    path: "candidate",
    title: "Date Of Departure",
  },
  {
    key: "candidate_flight_time_of_departure",
    path: "candidate",
    title: "Time Of Departure",
  },
  {
    key: "candidate_flight_date_of_arrival",
    path: "candidate",
    title: "Date Of Arrival",
  },
  {
    key: "candidate_flight_time_of_arrival",
    path: "candidate",
    title: "Time Of Arrival",
  },
  {
    key: "candidate_flight_country",
    path: "candidate",
    title: "Country",
  },
  {
    key: "candidate_flight_pax",
    path: "candidate",
    title: "Pax",
  },
  {
    key: "candidate_flight_pickup_to_be_arranged",
    path: "candidate",
    title: "Pickup to be Arranged",
  },
  {
    key: "candidate_flight_project_incharge",
    path: "candidate",
    title: "Project In charge",
  },
  {
    key: "candidate_flight_flight_status",
    path: "candidate",
    title: "Flight Status",
  },
];

// export default function selectionList(candidateData,currentList, filename,checkedList) {
//   console.log(candidateData,currentList,checkedList, "candidate data from excel");
//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Sheet1");

//   const titleRow = sheet.getRow(1);
//   titleRow.getCell(1).value = "SNO.";
//   for (let i = 0; i <= headings.length; i++) {
//     titleRow.getCell(i + 1).style = {
//       alignment: { horizontal: "center", vertical: "middle" },
//       fill: {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
//       },
//       border: {
//         top: { style: "thin", color: { argb: "FF000000" } }, // Black color
//         left: { style: "thin", color: { argb: "FF000000" } },
//         bottom: { style: "thin", color: { argb: "FF000000" } },
//         right: { style: "thin", color: { argb: "FF000000" } },
//       },
//     };
//     if (headings[i]?.key == "job_position_name") {
//       titleRow.getCell(i + 2).value = "ACTUAL PROFESSION";
//     } else {
//       titleRow.getCell(i + 2).value =
//         headings[i]?.title?.toUpperCase() ||
//         headings[i]?.key?.split("_")?.join(" ")?.toUpperCase();
//     }

//     const column = sheet.getColumn(i + 2);
//     column.width = 30;
//   }

//   // Set header height
//   sheet.getRow(1).height = 30;

//   const candidates = candidateData?.candidates || [];
//   const projectDetails = flattenObjectInObjects(candidateData?.project);
//   for (let i = 0; i < currentList?.length; i++) {
//     const row = sheet.getRow(i + 2);
//     row.getCell(1).value = i + 1;
//     for (let j = 0; j < headings.length; j++) {
//       if (headings[j].path == "candidate") {
//         row.getCell(j + 2).value = candidates[i][headings[j].key] || "-";
//       } else if (headings[j].path == "project") {
//         row.getCell(j + 2).value = projectDetails[headings[j].key] || "-";
//       }
//     }
//   }

//   // Generate the Excel file and initiate download
//   workbook.xlsx.writeBuffer().then((buffer) => {
//     const blob = new Blob([buffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename ? `${filename}.xlsx` : "Selection List.xlsx";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     +URL.revokeObjectURL(url);
//   });
// }
export default function selectionList(
  candidateData,
  currentList,
  filename,
  checkedList
) {
  console.log(
    "candidate data from excel",
    candidateData,
    currentList,
    checkedList
  );
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "SNO.";
  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } }, // Black color
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    if (headings[i]?.key == "job_position_name") {
      titleRow.getCell(i + 2).value = "ACTUAL PROFESSION";
    } else {
      titleRow.getCell(i + 2).value =
        headings[i]?.title?.toUpperCase() ||
        headings[i]?.key?.split("_")?.join(" ")?.toUpperCase();
    }

    const column = sheet.getColumn(i + 2);
    column.width = 30;
  }

  // Set header height
  sheet.getRow(1).height = 30;

  const candidates = candidateData?.candidates || [];
  const projectDetails = flattenObjectInObjects(candidateData?.project);

  // Filter candidates based on checkedList if it is provided
  const filteredCandidates = checkedList?.length
    ? candidates.filter((candidate) => checkedList.includes(candidate.id))
    : candidates;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit", // Numeric month
        year: "numeric",
      })
      .split("/")
      .join("-");
  };
  const formattedCandidates = filteredCandidates.map((candidate) => ({
    ...candidate,
    visa_stamping_date: candidate.visa_stamping_date
      ? formatDate(candidate.visa_stamping_date)
      : "-",
  }));

  for (let i = 0; i < filteredCandidates.length; i++) {
    const row = sheet.getRow(i + 2);
    row.getCell(1).value = i + 1;
    for (let j = 0; j < headings.length; j++) {
      if (headings[j].path == "candidate") {
        row.getCell(j + 2).value =
        formattedCandidates[i][headings[j].key] || "-";
      } else if (headings[j].path == "project") {
        row.getCell(j + 2).value = projectDetails[headings[j].key] || "-";
      }
    }
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}.xlsx` : "Selection List.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
